'use client';

import React from 'react';
import styled from 'styled-components';

type Args = {
  text: string;
  highlight: string;
  caseSensitive?: boolean;
};
export const useHighlight = (highlightColor = '#fcd430') => {
  const highlight = (args: Args) => {
    const { text, highlight, caseSensitive = true } = args;
    const manipulatedHighlight = highlight.replace('(', '\\(').replace(')', '\\)');

    const parts = text.split(new RegExp(`(${manipulatedHighlight})`, 'gi'));

    return (
      <span>
        {parts.map((part, i) => (
          <HighlightWrapper
            key={i}
            shouldHighlight={
              !part.localeCompare(highlight, undefined, { sensitivity: caseSensitive ? 'case' : 'base' })
            }
            highlightColor={highlightColor}
          >
            {part}
          </HighlightWrapper>
        ))}
      </span>
    );
  };

  return highlight;
};

type HighlightTextProps = {
  highlightColor: string;
  shouldHighlight: boolean;
};

const HighlightWrapper = styled.span<HighlightTextProps>`
  ${({ highlightColor, shouldHighlight }) => shouldHighlight && `background-color: ${highlightColor};`}};
`;
